import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useLocation } from 'react-router';

import textLogo from '@fly/assets/images/fly_text_logo.svg';
import { Link } from '@fly/core';
import { isAppRoutePath, routes } from '@fly/shared';
import { FlySvgSprite } from '@fly/svg';

import styles from './FlyNotfound.module.less';

export const FlyNotFound = () => {
  const { t } = useTranslation();
  const location = useLocation();

  const backPath = isAppRoutePath(location.pathname)
    ? routes.DASHBOARD.ROOT
    : '/';
  return (
    <div className={styles.notFoundContainer}>
      <div className={styles.notFoundWrapper}>
        <div className='gap-4 sm:grid-cols-6 sm:gap-6 grid flex-1 grid-cols-1'>
          <div className='p-4 sm:order-1 sm:col-span-4 order-2'>
            <img src={textLogo} alt='logo' />
            <div className={styles.notFoundText}>
              <div>
                <strong>404. </strong>
                {t('app.not_found.title', {
                  defaultValue: 'There is an error.',
                })}
              </div>
              <Trans
                i18nKey='app.not_found.subtitle'
                components={{ br: <br /> }}
              >
                The request was not found on this server.
                <br /> Reload or try again later a
              </Trans>
              <div>
                <Link to={backPath} size='4' underline='none'>
                  {t('app.not_found.cta', { defaultValue: 'Back to Home' })}
                </Link>
              </div>
            </div>
          </div>
          <div className='sm:order-2 sm:col-span-2 order-1 flex flex-col items-center justify-center'>
            <FlySvgSprite name='404' size={168} />
          </div>
        </div>
      </div>
    </div>
  );
};
